import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
// import {  submitAssessmentOutcome, fetchAssessmentOutcomes, submitAbdominalResponses, submitPrediabetesResponses } from "../../../api/AssessmentHelper";
import { fetchAssessmentOutcomes } from "../../../api/AssessmentHelper";
import Modal from "../../Shared/Modal";
import { Buffer } from "buffer"; 
import ClipLoader from "react-spinners/ClipLoader";
import { generateFullMedicalAssessmentReport } from "../../../utils/MedicalPdfGenerator";
import {
  fetchAbdominalAssessmentResponse,
  fetchPrediabetesAssessmentResponse,
  fetchIRAssessmentResponse
} from '../../../api/AssessmentHelper';
import { getUserId, getAccesstoken } from "../../../utils/auth";

const MedicalSubAssessment = () => {
  // const [activeCard, setActiveCard] = useState(null);
  // const [activeCardTitle, setActiveCardTitle] = useState(null);
  const [assessmentAdded, setAssessmentAdded] = useState(false);
  const [outcomes, setOutcomes] = useState({});
  const [responses, setResponses] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [generatingPDF, setGeneratingPDF] = useState(false);

  const userId = getUserId();
  const access_token = getAccesstoken();
  
  const navigate = useNavigate();
  

  // Assessment type mapping
  const ASSESSMENT_TYPES = {
    ABDOMINAL_OBESITY: "7a54fd47-a449-46fc-8fbc-a5e12d2b7c6f",
    PREDIABETES: "4b2f9c68-df89-421a-9872-098e01b7a2ef",
    IR: "cdf191f0-020d-45de-b9c9-a3bfa5610fcc"
  };

  // Fetch outcomes when component mounts
  useEffect(() => {
    const fetchOutcomes = async () => {
      try {
        setLoading(true);
        const outcomesMap = await fetchAssessmentOutcomes(access_token, userId);
        setOutcomes(outcomesMap);
      } catch (error) {
        console.error("Error fetching outcomes:", error);
        setOutcomes({});
      } finally {
        setLoading(false);
      }
    };

    if (userId && access_token) {      
      fetchOutcomes();
    }
  }, [userId, access_token]);

  const encodeData = (name) => {
    const obj = { name };
    return encodeURIComponent(Buffer.from(JSON.stringify(obj)).toString("base64"));
  };

  const handleStartAssessment = (cardId, cardTitle) => {
    const encodedData = encodeData(cardTitle);
    if (outcomes[cardId]) {
      navigate(`/user/medical-assessment/start/${cardId}?details=${encodedData}&mode=edit`);
      window.location.reload();
    } else {
      navigate(`/user/medical-assessment/start/${cardId}?details=${encodedData}`);
      window.location.reload();
    }
  };

  const handleViewResponses = (cardId, cardTitle) => {
    const encodedData = encodeData(cardTitle);
    navigate(`/user/medical-assessment/responses/${cardId}?details=${encodedData}`);
  };

  // Hardcoded assessment cards with UUID and type mapping
  const assessmentCards = [
    {
      id: ASSESSMENT_TYPES.ABDOMINAL_OBESITY,
      title: "Abdominal Obesity",
      description: "Assessment to measure risk factors related to abdominal obesity",
      type: "abdominal_obesity"
    },
    {
      id: ASSESSMENT_TYPES.PREDIABETES,
      title: "Insulin Resistance and Pre-diabetes",
      description: "Assessment to evaluate risk factors for pre-diabetes",
      type: "prediabetes"
    },
  ];

  const getAssessmentType = (assessmentId) => {
    const card = assessmentCards.find(card => card.id === assessmentId);
    return card ? card.type : null;
  };

  const calculateScore = (assessmentId, responses) => {
    let totalScore = 0;
    const assessmentType = getAssessmentType(assessmentId);

    if (assessmentType === "abdominal_obesity") {
      const waistCircumference = parseFloat(responses["ao_q6"]);
      const gender = responses["ao_q5"];
      const waisttoHeightRatio = parseFloat(responses["ao_q7"]);
      const BRI = parseFloat(responses["ao_q8"]);

      if (!isNaN(waistCircumference)) {
        if (gender === "Male" && waistCircumference > 94) {
          totalScore += 1;
        } else if (gender === "Female" && waistCircumference > 80) {
          totalScore += 1;
        }
      }
      if (!isNaN(waisttoHeightRatio)) {
        if (waisttoHeightRatio > 0.5) {
          totalScore += 1;
        }
      }
      if (!isNaN(BRI)) {
        if (BRI > 7) {
          totalScore += 1;
        }
      }
    } else if (assessmentType === "prediabetes") {
      const SerumFastingInsulin = parseFloat(responses["pd_q2"]);
      const FastingBloodglucose = parseFloat(responses["pd_q3"]);
      const HbA1c = parseFloat(responses["pd_q4"]);

      if (!isNaN(SerumFastingInsulin) && SerumFastingInsulin > 15) {
        totalScore += 1;
      }
      if (!isNaN(FastingBloodglucose) && FastingBloodglucose > 110) {
        totalScore += 1;
      }
      if (!isNaN(HbA1c) && HbA1c > 5.7) {
        totalScore += 1;
      }
    }

    return totalScore;
  };

  const handleResponseChange = (questionId, value) => {
    setResponses(prev => ({
      ...prev,
      [questionId]: value
    }));
  };

  // const handleSubmit = async () => {
  //   try {
  //     const createdAt = new Date().toISOString();
  //     const totalScore = calculateScore(activeCard, responses);

  //     if(activeCardTitle === 'Abdominal Obesity Assessment'){
  //       const questionMapping = {
  //         ao_q1: "height",
  //         ao_q2: "weight",
  //         ao_q3: "age",
  //         ao_q4: "bmi",
  //         ao_q5: "gender",
  //         ao_q6: "waist_circumference",
  //         ao_q7: "waist_height_ratio",
  //         ao_q8: "bri"
  //       };
  //       const userAbdominalResponses = Object.entries(responses).reduce((acc, [questionId, answer]) => {
  //         const field = questionMapping[questionId];  // Check if the questionId is mapped
  //         if (field) {
  //           acc[field] = isNaN(answer) ? answer : Number(answer);  // Convert to number if applicable
  //         }
  //         return acc;
  //       }, {
  //         user_id: userId,
  //         height: 0,
  //         weight: 0,
  //         age: 0,
  //         bmi: 0,
  //         gender: "string",  // Default gender if missing
  //         waist_circumference: 0,
  //         waist_height_ratio: 0,
  //         bri: 0,
  //         created_at: createdAt,
  //         created_by: userId
  //       });
        
  //       // Submit responses
  //       await submitAbdominalResponses(userAbdominalResponses, access_token);
  //     }else if(activeCardTitle === 'Insulin Resistance and Pre-diabetes Assessment'){
  //       const questionMapping = {
  //         pd_q1: "prediabetes_risk_score",
  //         pd_q2: "serum_fasting_insulin",
  //         pd_q3: "fasting_blood_glucose",
  //         pd_q4: "hba1c",
  //         pd_q5: "triglycerides",
  //         pd_q6: "hdl",
  //         pd_q7: "parent_sibling_diabetes",
  //         pd_q8: "physically_active"
  //       };

  //       const userPrediabetesResponses = Object.entries(responses).reduce((acc, [questionId, answer]) => {
  //         const field = questionMapping[questionId];  // Check if the questionId is mapped
  //         if (field) {
  //           acc[field] = isNaN(answer) ? answer : Number(answer);  // Convert to number if applicable
  //         }
  //         return acc;
  //       }, {
  //         user_id: userId,
  //         prediabetes_risk_score: 'no',
  //         serum_fasting_insulin: 0,
  //         fasting_blood_glucose: 0,
  //         hba1c: 0,
  //         triglycerides: 0,
  //         hdl: 0,
  //         parent_sibling_diabetes: '',
  //         physically_active: 'no',
  //         created_at: createdAt,
  //         created_by: userId
  //       });

  //       await submitPrediabetesResponses(userPrediabetesResponses, access_token);
        
  //     }
  //     else{
  //       setError("No active assessment details found!");
  //     }

  //     // Submit assessment outcome
  //     const assessmentOutcome = {
  //       user_id: userId,
  //       assessment_id: activeCard,
  //       total_score: totalScore,
  //       status: "completed",
  //       created_at: createdAt
  //     };

  //     await submitAssessmentOutcome(assessmentOutcome, access_token);

  //     // Update outcomes locally
  //     setOutcomes(prev => ({
  //       ...prev,
  //       [activeCard]: assessmentOutcome
  //     }));

  //     setAssessmentAdded(true);
  //     setTimeout(() => {
  //       setAssessmentAdded(false);
  //       navigate(`/user/results/${activeCard}`, {
  //         state: { assessmentName: activeCardTitle }
  //       });
  //     }, 2000);

  //   } catch (error) {
  //     console.error("Error submitting assessment:", error);
  //     setError("Failed to submit assessment");
  //   }
  // };

  // const renderQuestionOptions = (question) => {
  //   switch (question.question_type) {
  //     case "radio":
  //       return question.options.map((option, i) => (
  //         <div key={i} className="xsm option-item d-flex align-items-center gap-2">
  //           <input
  //             type="radio"
  //             id={`option${question.id}-${i}`}
  //             name={`question${question.id}`}
  //             value={option.option_label}
  //             checked={responses[question.id] === option.option_label}
  //             onChange={() => handleResponseChange(question.id, option.option_label)}
  //             className="form-check-input"
  //           />
  //           <label htmlFor={`option${question.id}-${i}`}>
  //             {option.option_label}
  //           </label>
  //         </div>
  //       ));
      
  //     case "text_input":
  //       return (
  //         <input
  //           type="text"
  //           className="form-control"
  //           value={responses[question.id] || ''}
  //           onChange={(e) => handleResponseChange(question.id, e.target.value)}
  //           placeholder="Enter your answer"
  //         />
  //       );
      
  //     default:
  //       return null;
  //   }
  // };

  const handleDownloadPDF = async () => {
    try {
        setGeneratingPDF(true);
        
        // Fetch all assessment responses
        const abdominalResponses = await fetchAbdominalAssessmentResponse(userId, access_token);
        const prediabetesResponses = await fetchPrediabetesAssessmentResponse(userId, access_token);
        const irResponses = await fetchIRAssessmentResponse(userId, access_token);

        // Process and structure the data
        const abdominalData = {
            bmi: abdominalResponses?.bmi || 0,
            bmi_range: getBMIRange(abdominalResponses?.bmi),
            waist_circumference: abdominalResponses?.waist_circumference || 0,
            waist_height_ratio: abdominalResponses?.waist_height_ratio || 0,
            bri: abdominalResponses?.bri || 0,
            gender: abdominalResponses?.gender || '',
            matching_conditions: calculateAbdominalMatchingConditions(abdominalResponses)
        };

        const prediabetesData = {
            serum_fasting_insulin: prediabetesResponses?.serum_fasting_insulin || 0,
            fasting_blood_glucose: prediabetesResponses?.fasting_blood_glucose || 0,
            hba1c: prediabetesResponses?.hba1c || 0,
            parent_sibling_diabetes: prediabetesResponses?.parent_sibling_diabetes || '',
            physically_active: prediabetesResponses?.physically_active || '',
            triglycerides: prediabetesResponses?.triglycerides || 0,
            hdl: prediabetesResponses?.hdl || 0,
            matching_conditions: []
        };

        const irData = {
            homa_ir: irResponses?.homa_ir || 0,
            tyg_index: irResponses?.tyg_index || 0,
            hdl_ratio: irResponses?.hdl_ratio || 0,
            gender: abdominalResponses?.gender || '',
            matching_conditions: calculateIRMatchingConditions(prediabetesResponses, irResponses)
        };

        // Generate PDF
        const pdfDoc = await generateFullMedicalAssessmentReport({
            abdominalData,
            prediabetesData,
            irData
        });

        // Download the PDF
        await pdfDoc.download('Medical_Assessment_Report.pdf');

    } catch (error) {
        console.error('Detailed error in PDF generation:', error);
        setError(error.message || 'Failed to generate PDF report. Please try again.');
    } finally {
        setGeneratingPDF(false);
    }
  };

  // Helper function to determine BMI range
  function getBMIRange(bmi) {
    if (!bmi) return '';
    if (bmi < 16) return 'Severe Thinness';
    if (bmi < 17) return 'Moderate Thinness';
    if (bmi < 18.5) return 'Mild Thinness';
    if (bmi < 25) return 'Normal';
    if (bmi < 30) return 'Overweight';
    if (bmi < 35) return 'Obesity Class I';
    if (bmi < 40) return 'Obesity Class II';
    return 'Obesity Class III';
  }

  // Helper functions for calculating conditions
  function calculateAbdominalMatchingConditions(data) {
    const conditions = [];
    if (!data) return conditions;

    const { waist_circumference, gender, waist_height_ratio, bri } = data;

    if ((gender === 'Male' && waist_circumference > 94) || 
        (gender === 'Female' && waist_circumference > 80)) {
        conditions.push('Waist Circumference');
    }

    if (waist_height_ratio > 0.5) {
        conditions.push('Waist to Height Ratio');
    }

    if (bri > 7) {
        conditions.push('BRI');
    }

    return conditions;
  }

  function calculateIRMatchingConditions(prediabetes, ir) {
    const conditions = [];
    if (!prediabetes || !ir) return conditions;

    if (ir.homa_ir > 1.23) {
        conditions.push('HOMA-IR');
    }

    if (ir.tyg_index > 4.65) {
        conditions.push('TyG Index');
    }

    if ((prediabetes.gender === 'Male' && ir.hdl_ratio > 3.4) || 
        (prediabetes.gender === 'Female' && ir.hdl_ratio > 2.6)) {
        conditions.push('Triglyceride-HDL Ratio');
    }

    return conditions;
  }

  if (loading) {
    return (
      <div className="loading-container">
        <ClipLoader color="#36d7b7" loading={loading} size={50} />
        <p>Loading assessments...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <p className="error-message">{error}</p>
        <button 
          className="btn-assessment"
          onClick={() => navigate('/login')}
        >
          Go to Login
        </button>
      </div>
    );
  }

  return (
    <div className="dashboard_grey_section">
      <div className="d-flex gap-2 justify-content-end mt-2 mb-2">
    <button
        onClick={handleDownloadPDF}
        style={{
            all: "unset",
            cursor: generatingPDF ? "not-allowed" : "pointer",
            fontSize: "22px",
            marginLeft: '10px',
            color: 'var(--theme-color)',
            opacity: generatingPDF ? 0.6 : 1,
        }}
        disabled={generatingPDF}
    >
        <i className="fa-solid fa-download icon"></i> Download Full Report
    </button>
</div>
      <h1 className="font-lg mb-4">Medical Assessment</h1>
      
      <div className="dashboard-user-name">
        <p>
          Evaluation of your current health status, body composition, abdominal obesity, insulin sensitivity and risk of Pre-diabetes and other metabolic disorders
        </p>
      </div>
      <div className="row mb-3">
        {assessmentCards.map((card) => (
          <div className="col-xl-6 mb-3" key={card.id}>
            <div className="assesment-cards">
              <div className="dashboard-title mb-3">
                <div className="font-md fw-semibold">{card.title}</div>
              </div>
              {/* <p>{card.description}</p> */}
              <div className="d-flex justify-content-end gap-2">
                {outcomes[card.id] && (
                  <button
                    onClick={() => handleViewResponses(card.id, card.title)}
                    className="btn-assessment font-xss btns btn-animation-blue mt-xxl-4 mt-2 home-button"
                  >
                    View <i style={{marginLeft: '10px'}} className="fa-solid fa-eye"></i>
                  </button>
                )}
                <button
                  onClick={() => handleStartAssessment(card.id, card.title)}
                  className="btn-assessment font-xss btns btn-animation-blue mt-xxl-4 mt-2 home-button"
                >
                  {outcomes[card.id] ? (
                    <>Edit <i className="fa-solid fa-edit icon"></i></>
                  ) : (
                    <>Start Now <i className="fa-solid fa-right-long icon"></i></>
                  )}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
      <Link to="/user/assessments" className="font-md">
        <i className="fa-solid fa-left-long icon"></i> Back
      </Link>
      {assessmentAdded && (
        <Modal
          title="Assessment Submitted!"
          modalType="success"
          bodyText="Responses stored successfully.."
          modalId="loginModal"
        />
      )}
    </div>
  );
};

export default MedicalSubAssessment;